import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

export const BulkRescheduleDialog = ({
  open, onOpenChange, selectedCount,
  bulkDeliveryDate, setBulkDeliveryDate, bulkDeliveryTime, setBulkDeliveryTime,
  onSubmit, submitting,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="bulk-reschedule-dialog">
      <DialogHeader>
        <DialogTitle>Bulk Reschedule</DialogTitle>
      </DialogHeader>
      <form onSubmit={(e) => { e.preventDefault(); if (!submitting) onSubmit(); }}>
      <div className="space-y-4">
        <div className="p-3 rounded" style={{ background: '#FBF9F6' }}>
          <p className="text-sm" style={{ color: '#1E2420' }}>
            Rescheduling <span className="font-bold" style={{ color: '#C05C35' }}>{selectedCount}</span> order{selectedCount !== 1 ? 's' : ''} to the new delivery date/time below.
          </p>
          <p className="text-xs mt-1" style={{ color: '#5C6B61' }}>Delivered orders are automatically skipped.</p>
        </div>
        <div>
          <label className="text-sm font-medium">New Delivery Date</label>
          <Input type="date" value={bulkDeliveryDate} onChange={(e) => setBulkDeliveryDate(e.target.value)} required data-testid="bulk-delivery-date-input" />
        </div>
        <div>
          <label className="text-sm font-medium">New Delivery Time</label>
          <Input type="time" value={bulkDeliveryTime} onChange={(e) => setBulkDeliveryTime(e.target.value)} required data-testid="bulk-delivery-time-input" />
        </div>
      </div>
      <DialogFooter className="mt-4">
        <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={submitting}>Cancel</Button>
        <Button type="submit" disabled={submitting} style={{ background: '#C05C35' }} data-testid="submit-bulk-reschedule-btn">
          {submitting ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Rescheduling...</> : `Reschedule ${selectedCount} Order${selectedCount !== 1 ? 's' : ''}`}
        </Button>
      </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);

export const BulkConfirmDialog = ({
  open, onOpenChange, selectedCount,
  bulkDeliveryDate, setBulkDeliveryDate, bulkDeliveryTime, setBulkDeliveryTime,
  onSubmit, submitting,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="bulk-confirm-dialog">
      <DialogHeader>
        <DialogTitle>Bulk Confirm Orders</DialogTitle>
      </DialogHeader>
      <form onSubmit={(e) => { e.preventDefault(); if (!submitting) onSubmit(); }}>
      <div className="space-y-4">
        <div className="p-3 rounded" style={{ background: '#FBF9F6' }}>
          <p className="text-sm" style={{ color: '#1E2420' }}>
            Confirming <span className="font-bold" style={{ color: '#2B5339' }}>{selectedCount}</span> order{selectedCount !== 1 ? 's' : ''} with the delivery schedule below.
          </p>
          <p className="text-xs mt-1" style={{ color: '#5C6B61' }}>Only orders with <b>pending</b> status will be confirmed; others are skipped.</p>
        </div>
        <div>
          <label className="text-sm font-medium">Delivery Date</label>
          <Input type="date" value={bulkDeliveryDate} onChange={(e) => setBulkDeliveryDate(e.target.value)} required data-testid="bulk-confirm-date-input" />
        </div>
        <div>
          <label className="text-sm font-medium">Delivery Time</label>
          <Input type="time" value={bulkDeliveryTime} onChange={(e) => setBulkDeliveryTime(e.target.value)} required data-testid="bulk-confirm-time-input" />
        </div>
      </div>
      <DialogFooter className="mt-4">
        <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={submitting}>Cancel</Button>
        <Button type="submit" disabled={submitting} style={{ background: '#2B5339' }} data-testid="submit-bulk-confirm-btn">
          {submitting ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Confirming...</> : `Confirm ${selectedCount} Order${selectedCount !== 1 ? 's' : ''}`}
        </Button>
      </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
